/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { RenderMapper, AttributesGroup } from '../../../types';
import { Layout } from '../../../constants';
import { groupAttributes as recurrenceGroupAttributes, mapper as recurrenceMapper } from '../recurrence';

const groupAttributeOrder: AttributesGroup[] = [
  {
    name: 'general',
    attributes: [
      'title',
      'slug', // code
      'description',
      'status',
      'tags',
      'relatedRequesters',
      'relatedAssignees',
      'reviewers',
      'notifyAssignee',
      'relatedVerifiers',
    ],
  },
  recurrenceGroupAttributes,
  {
    name: 'additional',
    label: 'Additional',
    expanded: false,
    attributes: ['relatedObjects', 'documents'],
  },
];

const mapper: RenderMapper = {
  ...recurrenceMapper,
  // TODO: Most of this attributes/fields are the same as Request ones
  // Maybe we could move these to ../generic.ts or create a new file
  title: {
    renderInfo: Layout.Columns.TwoThirds,
  },
  slug: {
    renderInfo: Layout.Columns.Third,
  },
  description: {
    renderInfo: Layout.Columns.Full,
  },
  notifyAssignee: {
    renderInfo: {
      noLabel: true,
      presenterAttributes: {
        moveUp: true,
      },
    },
    overrideAttributes: {
      displayName: 'Notify on task creation via email',
    },
  },
  documents: {
    renderInfo: {
      ...Layout.Columns.Full,
      ...Layout.Presenter.Half,
      presenterAttributes: {
        placeholder: 'Attachments can be added after saving.',
      },
    },
  },
};

export default {
  groupAttributeOrder,
  mapper,
};
